module.exports = __webpack_public_path__ + "img/LECO_logo.0342ea06.png";